import { render, staticRenderFns } from "./SendAmount.vue?vue&type=template&id=6698525e"
import script from "./SendAmount.vue?vue&type=script&lang=js"
export * from "./SendAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports